import {z} from 'zod'

export const STROKE_OPACITY_MAP_CIRCLE = 0.8
export const STROKE_WEIGHT_MAP_CIRCLE = 2
export const FILL_OPACITY_MAP_CIRCLE = 0.2
export const MARKER_COLOR_MAP_CIRCLE = '#ee7d00'
export const MAP_TYPE_ID_TERRAIN = 'terrain'
export const MAP_TYPE_ID_ROADMAP = 'roadmap'
export const MAP_TYPE = z.enum(['heatmap', 'markers', 'heatmap_and_markers'])
